/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function trsAddToCart() {
    return {
      error: '',
      buttonText: '',
      showError: false,
      color: null,
      loading: false,
      selectedPrice: null,
      selectedPennies: null,
      selectedVariantId: null,
      checkColorBeforeAdd(e) {
        if(this.color) {
          return this.addToCart();
        }
        window.location.href = this.$refs.link;
      },

      deselect($el) {
        $el.checked = false;
        this.selectedPrice = null;
        this.color = null;
        this.selectedVariantId = null;
      },

      addToCart() {

        this.loading = true;

        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        let formData = Form.serialize(this.$refs.form);

        // Alpine with x-data on form + input with name="id" throws an error, so working around this
        formData.id = formData.variant_id;

        fetch(`${window.routes.cartAddUrl}.js`, {
          body: JSON.stringify(formData),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then((response) => {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          this.loading = false;
          if (response.ok) {

            this.buttonText = 'Item added'

            setTimeout(() => this.buttonText = '', 2000);

            document.documentElement.dispatchEvent(new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            }));
            document.dispatchEvent(new CustomEvent("modal:close"));
          } else {
            response.json().then((content) => {
              this.showMessage(content["description"], "error");
            });
          }
        });
      },

      wholesalePrice(factor) {
        return window.theme.currency + (Math.ceil((this.selectedPennies * factor) / 100) / 100).toFixed(2);
      },

      showMessage(message, type) {
        this.error = message;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    }
  }

  function trsSlider() {
    return {
      init() {
        this.$nextTick(() => {
          this.slider = this.$refs.slider;
          this.scrollLeftBtn = this.$refs.left; 
          this.scrollRightBtn = this.$refs.right;

          this.updateButtonVisibility();

          // Set up event listeners
          this.slider.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this.updateButtonVisibility(), 50);
          });

          window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.updateButtonVisibility(), 150);
          });
        });
      },

      scrollLeft() {
        const amount = this.getScrollAmount();
        this.slider.scrollBy({
          left: -amount,
          behavior: 'smooth'
        });
      },

      scrollRight() {
        const amount = this.getScrollAmount();
        this.slider.scrollBy({
          left: amount,
          behavior: 'smooth'
        });
      },

      getScrollAmount() {
        return this.slider.clientWidth * 0.8;
      },

      updateButtonVisibility() {
        const tolerance = 1;
        const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;

        if (this.slider.scrollWidth <= this.slider.clientWidth) {
          this.scrollLeftBtn.classList.add('tw-opacity-0');
          this.scrollRightBtn.classList.add('tw-opacity-0');
          return;
        }

        if (this.slider.scrollLeft <= tolerance) {
          this.scrollLeftBtn.classList.add('tw-opacity-0');
        } else {
          this.scrollLeftBtn.classList.remove('tw-opacity-0');
        }

        if (this.slider.scrollLeft >= maxScrollLeft - tolerance) {
          this.scrollRightBtn.classList.add('tw-opacity-0');
        } else {
          this.scrollRightBtn.classList.remove('tw-opacity-0');
        }
      }
    }
  }

document.addEventListener('alpine:init', () => {
  Alpine.data('trsModal', () => ({
    open: false, 
    content: '', 
    title: '', 
    img: '', 
    actuallyOpen: false,

    init() {
      this.$watch('open', (v) => { 
        if(v) {
          setTimeout(() => this.actuallyOpen = true, 300);
        } else {
          setTimeout(() => {
            this.img = '';
            this.content = '';
            this.title = '';
          }, 300);            
        }
      });
    },

    populate($e) {
      this.open = true;      
      let data = JSON.parse($e.detail.data);
      this.title = data.title;
      this.content = data.content;
      this.img = data.img;
    }
  }))
});

// PDP: unselect variant and disable add button with exception for querystring
// let checkedProductOption = document.querySelector('product-form input[type=radio]:checked');
// let addBtn = document.querySelector('button.product-form__add-button.button.button--primary');
// if(checkedProductOption && document.location.search.indexOf('variant=') === -1) {
//   checkedProductOption.checked = false;
//   addBtn.classList.add('tw-opacity-50', 'tw-pointer-events-none');
//   // addBtn.innerHTML = 'Select color';
//   addBtn.innerHTML = 'Select Variant';
// }

// document.addEventListener('variant:changed', function(event) {
//   console.log("HELLO!");
// });

// c-main-card add to cart
(function() {
  const ORIGINAL_HTML = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M10.5 11.375H17.5M10.5 14.875H17.5M7 7.875H23.625L21.875 18.375H6.125L4.375 4.375H1.75M17.9375 21.4375C17.5894 21.7856 17.3938 22.2577 17.3938 22.75C17.3938 23.2423 17.5894 23.7144 17.9375 24.0625C18.2856 24.4106 18.7577 24.6062 19.25 24.6062C19.7423 24.6062 20.2144 24.4106 20.5625 24.0625C20.9106 23.7144 21.1062 23.2423 21.1062 22.75C21.1062 22.2577 20.9106 21.7856 20.5625 21.4375C20.2144 21.0894 19.7423 20.8938 19.25 20.8938C18.7577 20.8938 18.2856 21.0894 17.9375 21.4375ZM7.4375 21.4375C7.26514 21.6099 7.12842 21.8145 7.03514 22.0397C6.94186 22.2649 6.89384 22.5062 6.89384 22.75C6.89384 23.2423 7.0894 23.7144 7.4375 24.0625C7.7856 24.4106 8.25772 24.6062 8.75 24.6062C9.24228 24.6062 9.7144 24.4106 10.0625 24.0625C10.4106 23.7144 10.6062 23.2423 10.6062 22.75C10.6062 22.2577 10.4106 21.7856 10.0625 21.4375C9.7144 21.0894 9.24228 20.8938 8.75 20.8938C8.25772 20.8938 7.7856 21.0894 7.4375 21.4375Z" stroke="white" stroke-width="1.4" stroke-linejoin="round"/></svg> Add to Cart`;

  function initCCards() {
    document.querySelectorAll('.c-add-to-cart:not([data-atc-init])').forEach(function(btn) {
      btn.setAttribute('data-atc-init', 'true');

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (btn.dataset.processing === 'true') return;
        btn.dataset.processing = 'true';

        var id = btn.dataset.variantId;
        if (!id) { btn.dataset.processing = 'false'; return; }

        btn.disabled = true;
        btn.innerHTML = 'Adding...';
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function(res) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'Error'); });
          return res.json();
        })
        .then(function() {
          btn.innerHTML = '✓ Added';
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { quantity: 1 }
          }));
          setTimeout(function() {
            btn.innerHTML = ORIGINAL_HTML;
            btn.disabled = false;
            btn.dataset.processing = 'false';
          }, 2000);
        })
        .catch(function(err) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          btn.innerHTML = err.message || 'Error';
          setTimeout(function() {
            btn.innerHTML = ORIGINAL_HTML;
            btn.disabled = false;
            btn.dataset.processing = 'false';
          }, 2500);
        });
      });
    });
  }

 initCCards();
  document.addEventListener('shopify:section:load', initCCards);
})();

(function () {
  function refresh(list) {
    var moreItem = list.querySelector('.trs-slider__swatch-more-item');
    if (!moreItem) return;

    var swatches = list.querySelectorAll('.colour-swatch-item');
    if (!swatches.length || list.classList.contains('is-expanded')) {
      moreItem.hidden = true;
      return;
    }

    var tops = [];
    for (var i = 0; i < swatches.length; i++) tops.push(swatches[i].offsetTop);
    var firstTop = Math.min.apply(null, tops);
    var hidden = 0;
    for (var j = 0; j < tops.length; j++) {
      if (tops[j] > firstTop) hidden++;
    }

    if (hidden > 0) {
      moreItem.querySelector('[data-swatch-more-count]').textContent = '+' + hidden;
      moreItem.hidden = false;
    } else {
      moreItem.hidden = true;
    }
  }

  function refreshAll() {
    var lists = document.querySelectorAll('.trs-slider__swatch-list');
    for (var i = 0; i < lists.length; i++) refresh(lists[i]);
  }

  var queued = null;
  function schedule() {
    if (queued) clearTimeout(queued);
    queued = setTimeout(function () {
      queued = null;
      refreshAll();
    }, 150);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.trs-slider__swatch-more');
    if (!button) return;
    event.preventDefault();
    var list = button.closest('.trs-slider__swatch-list');
    if (!list) return;
    list.classList.add('is-expanded');
    button.setAttribute('aria-expanded', 'true');
    button.closest('.trs-slider__swatch-more-item').hidden = true;
  });

  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
